export default {
  WithoutItemCard: {
    field: {
      title: 'You still have no active field',
      text: 'All your fields will appear here.',
      create_field: 'Create field',
    },
    sowing: {
      title: 'You still have no active sowing in the current season',
      text: 'All your sowings from the current season will appear here.',
      execute_sowing: 'Execute sowing',
    },
    filter: {
      not_found_title: 'No results found',
      not_found_text: 'Try changing the filters',
    },
    integrations: {
      title: 'You still have no active integration',
      text: 'All your integrations will appear here.',
      add_integration: 'Add integration',
    },
  },
  FarmDisabled: {
    farm_disabled: 'Hacienda deshabilitada',
    farm_disabled_message_banner_text1: 'Enable farm to register',
    farm_disabled_message_banner_text2:
      'You will only be able to register if your farm is enabled. Click the button below to manage farms.',
    manager_farms: 'Manage farms',
  },
}
